import React from "react";
import { FlexContainer } from "./styles";
import { FlexProps } from "./propTypes";

export const Flex = ({ children, ...rest }) => {
	return <FlexContainer {...rest}>{children}</FlexContainer>;
};

Flex.propTypes = {
	...FlexProps
};
